import React from "react";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { historyPage, seo, business } from "../data/siteData";

export default function History() {
  useSeo(
    seo["/our-history-and-experience"].title,
    seo["/our-history-and-experience"].description
  );
  useReveal();
  return (
    <>
      <PageHero image={historyPage.hero} title={historyPage.h1} />
      <section className="bg-white py-16">
        <div className="mr-container mr-body reveal">
          {historyPage.paragraphs.map((p) => (
            <p key={p.slice(0, 30)} className="text-[16.5px]">
              {p}
            </p>
          ))}
          <div className="mt-8 border-l-4 border-[#a10000] bg-[#f7f7f7] p-6">
            <h2 className="font-head text-sm font-extrabold uppercase tracking-widest text-[#242424]">
              Service Area
            </h2>
            <p className="mt-2 mb-0">{business.serviceArea}</p>
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
